<template>
  <el-form class="area-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="oneFlag">
      <template slot="label">数量</template>
      <div class="ref-one-flag-row">
        <el-radio-group v-model="control.oneFlag" @change="changeDefault">
          <el-radio :label="true">一条</el-radio>
          <el-radio :label="false">多条</el-radio>
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item prop="level">
      <template slot="label">地址格式</template>
      <el-select v-model="control.level" placeholder="请选择">
        <el-option
          v-for="item in addressLevel"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-checkbox v-model="control.lastLevelOnly" label="必须选择到最后一项"></el-checkbox>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <default-val-input
        ref="defaultVal"
        :key="control._cid"
        :cur-control="control"
        :sheet="sheet"
        :available-sheet-map="availableSheetMap"
        :value="control.defaultVal"
      ></default-val-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import { addressLevel } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import DefaultValInput from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/default-val-input"
export default {
  name: "area-control",
  components: { DefaultValInput },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: Object
  },
  data() {
    return {
      addressLevel
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    changeDefault() {
      this.control.defaultVal = this.$refs.defaultVal.resetRes()
    }
  }
}
</script>

<style lang="scss" scoped>
.area-control {
}
</style>
